export default __webpack_public_path__ + "static/media/Services_Pic.32778b2b.png";